import Phaser from 'phaser';

import { generateSprites } from '../graphics/generateSprites';
import { launchGameScene } from '../types/GameSceneLaunchData';
import { LEVEL_COUNT, UUID_TO_INDEX } from '../levels/index';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;

    const progressBar = this.add.graphics();
    const progressBox = this.add.graphics();
    progressBox.fillStyle(0x333355, 0.8);
    progressBox.fillRect(width / 2 - 320, height / 2 - 30, 640, 60);

    this.load.on('progress', (value: number) => {
      progressBar.clear();
      progressBar.fillStyle(0x3498db, 1);
      progressBar.fillRect(width / 2 - 300, height / 2 - 20, 600 * value, 40);
    });

    this.load.on('complete', () => {
      progressBar.destroy();
      progressBox.destroy();
    });
  }

  create(): void {
    generateSprites(this.textures);

    // Check URL params for scene routing
    const params = new URLSearchParams(window.location.search);

    // Dev/admin: direct level jump via ?level=<uuid> or ?level=<N>
    const levelParam = params.get('level');
    if (levelParam) {
      // Try numeric index first (backwards compat: ?level=5)
      const numericLevel = parseInt(levelParam, 10);
      if (!isNaN(numericLevel) && String(numericLevel) === levelParam && numericLevel >= 1 && numericLevel <= LEVEL_COUNT) {
        launchGameScene(this, { level: numericLevel });
        return;
      }
      // Try UUID lookup (stable: ?level=5e06b9f4-b92c-4e21-9edc-9728a3f5e92b)
      const uuidIndex = UUID_TO_INDEX.get(levelParam);
      if (uuidIndex !== undefined) {
        launchGameScene(this, { level: uuidIndex + 1 });
        return;
      }
    }

    // URL state persistence: ?scene=levelSelect&page=N
    const sceneParam = params.get('scene');
    if (sceneParam === 'levelSelect') {
      const page = parseInt(params.get('page') ?? '0', 10);
      this.scene.start('LevelSelectScene', { page });
      return;
    }

    this.scene.start('MenuScene');
  }
}
